<template>
  <div class="resource-introduction">
    <!-- description 资源介绍 -->

  </div>
</template>
<script type="text/babel">

  import 'animate.css';
  import { WOW } from 'wowjs'

  export default {
    components: {
    },
    data: function() {
      return {
      };
    },
    name: '',
    mounted() {
      let wow = new WOW({
        boxClass: 'wow',
        animateClass: 'animated',
        offset: 0,
        mobile: true
      });
      wow.init();
    },
    methods: {
    }
  }
</script>
<style scoped="scoped">
  @import '../../../../assets/css/frontHome.css';
</style>
<style>



</style>



// WEBPACK FOOTER //
// src/pages/front/introduce/resource-introduction/index.vue